/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type SearchContextInstancesPathParams = NonNullable<operations['searchContextInstances']['parameters']['path']>;

export type SearchContextInstancesQueryParams = NonNullable<
  operations['searchContextInstances']['parameters']['query']
>;

export type SearchContextInstancesRequestBody = OperationRequestBodyContent<operations['searchContextInstances']>;

export interface Input extends SearchContextInstancesPathParams {
  apiVersion?: string;
  query?: SearchContextInstancesQueryParams;
  body: SearchContextInstancesRequestBody;
}

export async function searchContextInstances(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/context-instances/search', {
    params: { path, query },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
